<template>
  <div class="page_error">
    <div>
      <v-icon class="error_icon">remove_circle_outline</v-icon>
    </div>
    <div class="error_text">
      <h1>403</h1>
      <h3>Acesso negado</h3>
      <p>O seu acesso a este recurso do SIGED está negado!<br> {{ mensagemErro}}</p>
    </div>
  </div>
</template>
<script>
export default {
  data: function() {
     return{
        mensagemErro: sessionStorage.mensagemErroHttp
     }
  }
    
}
</script>
<style lang="scss" scoped>

</style>
